import debug from 'debug';
import Utils from 'Global/Shared/Components/Utils/Utils';
import CloudApi from './CloudApi'

const log = debug('CloudApi:Adverts');
const utils = new Utils();

/**
 * @deprecated use api-management instead, and create missing functionality
 */
class Adverts extends CloudApi {

	/**
	 * Obsolete: Use product() instead
	 * @param {string} id
	 */
	Adverts(id) {
		let url = `//${this.settings.cloudApiUrl}/products/${ id }`;
		return this.Get(url);
	}

	AdvertsWithDuplicates(id) {
		let url = `//${this.settings.cloudApiUrl}/products/${ id }/withduplicates`;
		return this.Get(url);
	}

	PickByCategories(categoryIDs, customerIDs, maxCount) {
		log(customerIDs, typeof customerIDs);
		let parameters = '';
		if (customerIDs !== '') {
			parameters = `&customers=${customerIDs}`;
		}
		if (maxCount !== '') {
			parameters += `&resultsPerCategory=${maxCount}`;
		}

		let url = `//${this.settings.cloudApiUrl}/products/pickbycategories?categories=${categoryIDs}${parameters}`;
		return this.Get(url);
	}

	/**
	 * Obsolete: Use productsByCustomers() instead
	 * @param {Object} options 
	 * @param {string} options.customers Pipe separated: A list of customer ids to fetch adverts for
	 * @param {string} [options.category] A category id to filter the results by. Can be empty
	 * @param {number} [options.resultsPerCustomer] The amount of adverts per customer
 	 * @param {string} [options.totalNumberOfResults] The total amount of adverts to return
	 */
	PickByCustomers(options) {
		log('PickByCustomers() - options', options);
		let url = `//${this.settings.cloudApiUrl}/products/pickbycustomers?customers=${options.customers}`;

		if (!utils.IsNullOrWhiteSpace(options.category)) url += `&category=${options.category}`;
		if (!utils.IsNullOrWhiteSpace(options.resultsPerCustomer)) url += `&resultsPerCustomer=${options.resultsPerCustomer}`;
		if (!utils.IsNullOrWhiteSpace(options.totalNumberOfResults)) url += `&totalNumberOfResults=${options.totalNumberOfResults}`;

		log('PickByCustomers() - url', url);
		
		return this.Get(url);
	}

	/**
	 * @param {string} id
	 * 
	 * @returns {Promise} product
	 */
	product(id) {
		const url = `//${this.settings.cloudApiUrl}/products/${ id }`;
		return this.Get(url);
	}

	/**
	 * @param {string} facets querystrings [customers, category, resultPerCustomer, totalNumberOfResults]
	 * @returns {Promise}
	 */
	productsByCutomers(facets) {
		const url = `//${this.settings.cloudApiUrl}/products/pickbycustomers?${facets}`;
		return this.Get(url);
	}

}

export default Adverts;
